'use client';

import { useAuth } from '@/contexts/AuthContext';

export { useAuth };